import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row align-items-stretch"
}
const _hoisted_2 = { class: "card ticket-pack-card h-100" }
const _hoisted_3 = { class: "card-body text-center text-white align-items-center justify-content-center d-flex flex-column" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_7 = {
  key: 2,
  class: "w-75 mx-auto"
}
const _hoisted_8 = {
  key: 3,
  class: "w-50 mx-auto"
}
const _hoisted_9 = {
  key: 4,
  class: "w-50 mx-auto"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#ticketModalAssign",
  class: "btn btn-primary me-2"
}
const _hoisted_12 = {
  key: 1,
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#ownTicketModalView",
  class: "btn btn-primary me-2"
}
const _hoisted_13 = {
  key: 2,
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#ticketModal",
  class: "btn btn-secondary"
}
const _hoisted_14 = {
  key: 0,
  class: "col-3 mb-4 d-none d-xl-flex"
}
const _hoisted_15 = { class: "card w-100" }
const _hoisted_16 = { class: "card-body d-flex align-items-center justify-content-center flex-column" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  key: 1,
  class: "col-3 mb-4 d-none d-xl-flex"
}
const _hoisted_20 = {
  class: "modal fade",
  id: "ownTicketModalView",
  tabindex: "-1",
  "aria-labelledby": "ownTicketModalViewLabel",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "modal-dialog modal-lg" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = {
  class: "modal-body text-center",
  style: {"background":"linear-gradient(\n              135deg,\n              #0a0a0a,\n              #121212,\n              #232323,\n              #e5142b,\n              #e8b647\n            )"}
}
const _hoisted_24 = {
  class: "modal fade",
  id: "ticketModalAssign",
  tabindex: "-1",
  "aria-labelledby": "ticketModalAssignLabel",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog modal-lg" }
const _hoisted_26 = { class: "modal-content" }
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_29 = {
  key: 0,
  class: "col-6 mt-3 mx-auto"
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_32 = {
  key: 0,
  class: "col-6 mt-3 mx-auto"
}
const _hoisted_33 = { class: "modal-footer" }
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_ticket_template = _resolveComponent("ticket-template")!
  const _component_team_member = _resolveComponent("team-member")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_ctx.pendingTickets || _ctx.noPaidTickets) > 0 || _ctx.ownTicket)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-4 col-12", _ctx.ownTicket || _ctx.home ? 'col-xl-9' : 'col-xl-12'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                ((_ctx.pendingTickets || _ctx.noPaidTickets) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (!_ctx.home)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Comparte tus boletos con tu red."))
                        : _createCommentVNode("", true),
                      (_ctx.home)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_6, " La fecha se acerca, comparte los boletos con tu red. "))
                        : _createCommentVNode("", true),
                      (!_ctx.home)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _cache[2] || (_cache[2] = _createTextVNode(" Cuentas con ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.pendingTickets) + " boletos", 1),
                            _cache[3] || (_cache[3] = _createTextVNode(" disponibles de", -1)),
                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("i", null, _toDisplayString(_ctx.pendingTickets + _ctx.noPaidTickets) + " boletos en total", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.home && _ctx.pendingTickets > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                            _cache[5] || (_cache[5] = _createTextVNode(" Recuerda que aún cuentas con ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.pendingTickets) + " boletos", 1),
                            _cache[6] || (_cache[6] = _createTextVNode(" diponibles para compartir entre toda tu red. Aprovecha hoy mismo y comparte esos boletos. ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.home && _ctx.pendingTickets == 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                            _cache[7] || (_cache[7] = _createTextVNode(" Cuentas con ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.noPaidTickets) + " boletos", 1),
                            _cache[8] || (_cache[8] = _createTextVNode(" pendientes de pago. Completa tus pagos para que puedas liberarlos. ", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.pendingTickets || _ctx.noPaidTickets) == 0 && _ctx.ownTicket)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("h2", { class: "mb-0" }, "Tu boleto esta listo.", -1),
                      _createElementVNode("p", { class: "mb-3" }, "Aquí podrás visualizar tu boleto.", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (!_ctx.ownTicket && _ctx.pendingTickets > 0)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-ticket-alt me-1" }, null, -1),
                        _createTextVNode(" Seleccionar mi boleto ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.ownTicket)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_12, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "fas fa-ticket-alt text-white me-1" }, null, -1),
                        _createTextVNode(" Mi boleto ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (!_ctx.home && _ctx.pendingTickets > 0)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_13, " Asignar tickets "))
                    : _createCommentVNode("", true),
                  (_ctx.home && (_ctx.pendingTickets || _ctx.noPaidTickets) > 0)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 3,
                        to: "/tickets",
                        class: "btn btn-secondary lh-sm"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.pendingTickets > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-ticket-alt me-1" }, null, -1)),
                                _cache[13] || (_cache[13] = _createTextVNode(" Ver boletos ", -1))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.pendingTickets == 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-money-bill me-1" }, null, -1)),
                                _cache[15] || (_cache[15] = _createTextVNode(" Realiza tu pago ", -1))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 2),
          (_ctx.ownTicket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h5", _hoisted_17, [
                      _cache[16] || (_cache[16] = _createTextVNode("Usuario: ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.ownTicket.username), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _cache[17] || (_cache[17] = _createTextVNode("Tipo: ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.ownTicket.option.name), 1)
                    ]),
                    _createVNode(_component_vue_qrcode, {
                      ref: "qrcode",
                      value: _ctx.ownTicket?._id,
                      options: { ..._ctx.QRoptions, scale: 5 }
                    }, null, 8, ["value", "options"]),
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.ownTicket?._id), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.home && !_ctx.ownTicket && _ctx.pendingTickets > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("div", { class: "card h-100 px-3" }, [
                  _createElementVNode("div", { class: "card-body d-flex align-items-center justify-content-center flex-column text-center" }, [
                    _createElementVNode("p", null, "Aún no tienes tu boleto asignado. Seleccionalo ahorita mismo."),
                    _createElementVNode("button", {
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#ticketModalAssign",
                      class: "btn btn-primary"
                    }, [
                      _createElementVNode("i", { class: "fas fa-ticket-alt me-1" }),
                      _createTextVNode(" Seleccionar mi boleto ")
                    ])
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "ownTicketModalViewLabel"
            }, "Mi boleto"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.ownTicket)
              ? (_openBlock(), _createBlock(_component_ticket_template, {
                  key: 0,
                  ticket: _ctx.ownTicket,
                  event: _ctx.event
                }, null, 8, ["ticket", "event"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "ticketModalAssignLabel"
            }, [
              _createElementVNode("i", { class: "fas fa-ticket-alt me-1" }),
              _createTextVNode(" Seleccionar mi ticket ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_27, [
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-center" }, "Desde esta sección podrás eligir que tipo de boleto quieres seleccionar para ti. ", -1)),
            (_ctx.selected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  (!_ctx.selectedError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(), _createBlock(_component_team_member, {
                          simple: true,
                          key: _ctx.selected.usernamePK,
                          "member-data": _ctx.selected,
                          maxPointsPerUser: _ctx.selected.nextRankMaxPoints,
                          "team-side": 'true'
                        }, null, 8, ["member-data", "maxPointsPerUser"])),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select mt-2",
                          required: "",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event))
                        }, [
                          _cache[20] || (_cache[20] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "Selecciona el tipo de boleto", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option.id,
                              value: option.id
                            }, _toDisplayString(option.name) + " (" + _toDisplayString(option.count) + ") ", 9, _hoisted_30))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedOption]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_ctx.selectedError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.selectedError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[23] || (_cache[23] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cerrar", -1)),
            _createElementVNode("button", {
              "data-bs-dismiss": "modal",
              type: "button",
              class: "btn btn-success text-white",
              disabled: !_ctx.selected,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setTicket && _ctx.setTicket(...args)))
            }, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("i", { class: "fas fa-ticket-alt text-white" }, null, -1),
              _createTextVNode(" Seleccionar Boleto ", -1)
            ]))], 8, _hoisted_34)
          ])
        ])
      ])
    ])
  ], 64))
}